<dss-shared-lib-autocomplete-list-filter
    [formControl]="institutionControl"
    [elements]="institutions$ | ngrxPush"
    [searchPlaceholder]="'dssSharedLibFlightZone.applicationListFilters.textInputPlaceholder' | transloco"
    (searchTextChange)="institutionSearchTextChange.emit($event)"
>
    <label>{{ "dssSharedLibFlightZone.applicationListFilters.institutionLabel" | transloco }}</label>
</dss-shared-lib-autocomplete-list-filter>
